import styles from "app.style";
import { GameInstance, GameInstanceHistory, GameInstanceHistoryOddEven, TabGameItem, UserInfo } from "models/gameModel";
import { useState } from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import LiveItem from "components/live-item";
import Modal from "components/modal/Modal";
import HistoryBet from "components/history-bet/HistoryBet";
import { RootState, useAppSelector } from "cache/store";

interface Props {
	balance: number;
	tabGame: TabGameItem[];
	tabActive: TabGameItem;
	onChangeTab: (tab: TabGameItem) => void;
	gamesActive: GameInstance[];
	gameAll: GameInstance[];
	historyIssue: GameInstanceHistory;
	totalOddEven: GameInstanceHistoryOddEven;
	launchGame: (gameId: number) => void;
	onGoBack: () => void;
}

export default function BoardDesktop(props: Props) {
	const { balance, tabGame, tabActive, onChangeTab, gamesActive, gameAll, historyIssue, totalOddEven, launchGame, onGoBack } = props;
	const [showHistory, setShowHistory] = useState(false);
	const { userData } = useAppSelector((state: RootState) => state.auth);

	return (
		<>
			<div className={styles.page}>
				<div className="container">
					<div className={styles.header}>
						<div className="logo">
							<img src={require("assets/images/logo.png")} alt="" />
							<h6>LIVE DEALER</h6>
						</div>
						<button type="button" className="btn-exit" onClick={onGoBack}>
							<img src={require("assets/images/icon-exit.png")} alt="" />
							<span>Thoát</span>
						</button>
					</div>
					<div className={styles.body}>
						<div className="body-top">
							<div className="user-info">
								<div className="info-1">
									<div className="left">
										<p>ID: {userData.id}</p>
										<p className="username">{userData.nickname}</p>
									</div>
									<button type="button" className="btn-history">
										<div className="button-inner" onClick={() => setShowHistory(true)}>
											<img src={require("assets/images/icon-history.png")} alt="" />
											<span>Lịch sử cược</span>
										</div>
									</button>
								</div>
								<div className="info-2">
									<div className="balance">
										<img src={require("assets/images/icon-money.png")} alt="" />
										<span>{new Intl.NumberFormat().format(balance || 0)}</span>
									</div>
								</div>
							</div>
							<div className={styles.bannerSlide}>
								<Swiper
									autoplay={{
										delay: 10000,
									}}
									modules={[Pagination, Autoplay]}
									pagination={{ clickable: true }}
									speed={600}
									loop
								>
									<SwiperSlide>
										<img className="banner-image" src={require("assets/images/banners/banner01.jpg")} alt="" loading="lazy" />
									</SwiperSlide>
								</Swiper>
							</div>
						</div>
						<div className="tab-list">
							{tabGame.map((tab) => (
								<div className={`tab-item ${tabActive.value === tab.value ? "active" : ""}`} key={tab.value} onClick={() => onChangeTab(tab)}>
									<div className={`tab-item-inner ${!tab.isReady ? "comming" : ""}`}>
										<p>{tab.label}</p>
										{tab.isReady && <div className="label-new">NEW</div>}
										{!tab.isReady && <div className="label-comming">COMING SOON</div>}
									</div>
								</div>
							))}
						</div>
						<div className="game-list">
							{gamesActive.map((game) => (
								<LiveItem key={game.id} gameInstance={game} historyData={historyIssue[game.id]} statsTotal={totalOddEven[game.id]} onPlayGame={launchGame} typeGame={tabActive.path} />
							))}
						</div>
					</div>
				</div>
			</div>
			<Modal isShow={showHistory} onClose={() => setShowHistory(false)} width="55%" maxWidth="800px">
				<HistoryBet gameList={gameAll} onClose={() => setShowHistory(false)} liveGameId={tabActive.value} />
			</Modal>
		</>
	);
}
